import { __decorate } from "tslib";
import { Component, ViewEncapsulation, } from '@angular/core';
import { Router } from '@angular/router';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
let VoucherBannerComponent = class VoucherBannerComponent {
    constructor(router, webSettingsService, sanitizer, themeService, googleAnalyticsService) {
        this.router = router;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.googleAnalyticsService = googleAnalyticsService;
        this.borderRadiusSmaller = '';
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    goToVoucherPage(event) {
        this.sideMenuClick('voucher');
        this.router.navigateByUrl('voucher');
    }
    sideMenuClick(category) {
        let array = [];
        array.push({
            'event': 'sideMenuCTAclick',
            button: category
        });
        this.googleAnalyticsService.pushGAEvents(array);
    }
};
VoucherBannerComponent.ctorParameters = () => [
    { type: Router },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: GoogleAnalyticsService }
];
VoucherBannerComponent = __decorate([
    Component({
        selector: 'ecd-voucher-banner',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./voucher-banner.component.html")).default
    })
], VoucherBannerComponent);
export { VoucherBannerComponent };
